import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import {
  ClubMessageFormController,
  type ClubMessageFormProps,
} from "components/Pages/Club/ClubMessageFormController";
import { injectModal } from "lib/injectParams";
import routeService from "services/RouteService";

const NewClubMessageModal: React.FC<ClubMessageFormProps> = () => {
  const controller = ClubMessageFormController.use();
  const { loading, saving, errors } = controller.state;
  const fields = Object.values(controller.fields());

  if (loading) return <LoadingModal title="New message" />;

  return (
    <AppModal title="New message">
      <div className="flex min-w-[420px] max-w-xl flex-col gap-3">
        <p className="text-sm text-gray-600">Players see these updates in the player portal.</p>
        {errors.body ? <p className="text-sm text-red-600">{errors.body}</p> : null}
        <Form name="club_message">
          <fieldset disabled={saving}>
            <ModalFormFieldset fields={fields} />
          </fieldset>
          <div className="mt-4 flex justify-end">
            <FormButtons showDelete={false} showCancel saveTitle="Add message" />
          </div>
        </Form>
      </div>
    </AppModal>
  );
};

const NewClubMessageModalScoped = ClubMessageFormController.scope(ApplicationView(NewClubMessageModal));

export default injectModal((props: { clubId: string }) => (
  <NewClubMessageModalScoped
    {...props}
    attributes={{}}
    onSubmit={async () => {
      routeService.closeModal();
    }}
  />
));
